// extracted by mini-css-extract-plugin
export default {"title":"ProfileSubscriptionSkeleton_title__RfHV7","price":"ProfileSubscriptionSkeleton_price__x-LIT"};